import type { HostTelemetryContext, IHostTelemetryContextSource, TuningIdentity } from '@playcastdotio/PeerCore';

/** Projection port keeps source, native parameters and policy ownership with their managers. */
export class HostTelemetryContextAdapter implements IHostTelemetryContextSource {
  constructor(private readonly read: (target: TuningIdentity) => HostTelemetryContext) {}
  public snapshot(target: TuningIdentity): HostTelemetryContext { return { ...this.read(target) }; }
}
